'use strict';
define(
	'run',['settings', 'errorHandler', 'gameLoader', 'version', 'translations', 'streamControl',
		'jquery', 'jackpots', 'qlib', 'hlsPlayer', 'betgamesIframePlayer'
	],
	function (settings, errorHandler, gameLoader, version, T, streamControl, $, Jackpots,
		qLib, hls, betgamesIframePlayer) {
		function parseQueryArgs(q) {
			return (function (a) {
				var b = {},
					i,
					p;

				if (a === '') {
					return {};
				}

				for (i = 0; i < a.length; ++i) {
					p = a[i].split('=');
					if (p.length !== 2) {
						continue;
					}

					b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
				}
				return b;
			}(q.split('&')));
		}

		function init() {
			var configData = parseQueryArgs(location.search.substring(1)),
				invalidUrl;

			configData.games = configData.games ?
				JSON.parse(configData.games) :
				[configData.configUrl];

			invalidUrl = configData.games.some(function (game) {
				return game === undefined;
			});

			if (invalidUrl) {
				errorHandler.showError('Incorrect provided settings URL. Please check it and try again.',
					10000);
				return;
			}

			loadVersion();
			loadConfig('config.json')
				.fail(function () {
					errorHandler.showError('Failed to load config', 5000);
				})
				.done(function (localConfig) {
					Object.assign(settings.local, localConfig);

					// Configure error handler
					errorHandler.reconfigure(formatErrorConfig(localConfig.logging));

					if (configData.configOverride) {
						Object.assign(settings.local, JSON.parse(configData.configOverride));
					}

					if (typeof window.ga === 'function') {
						window.ga('create', settings.local.googleAnalyticsKey, 'auto');
						window.ga('send', 'pageview');
					}

					initialGameSettingsLoad(configData.games, function () {
						var ua = userAgentVersionMap(navigator.userAgent),
							isWeb = !(ua.ABOX || ua.MAC),
							playerContainerID = 'player',
							soundToggleButtonID = 'player-volume',
							iframePlayer = betgamesIframePlayer(playerContainerID, settings.player.partnerID),
							hlsPlayer = hls(playerContainerID);

						streamControl.setIframePlayer(iframePlayer);
						streamControl.setHLSPlayer(hlsPlayer);
						streamControl.setWeb(isWeb);

						if (isWeb) {
							streamControl.initSoundToggleButton(soundToggleButtonID);
						}
					});
				});
		}

		function initialGameSettingsLoad(games, callback) {
			var promisses = [];

			games.forEach(function (gameConfigUrl, index) {
				settings.games[index] = { configUrl: gameConfigUrl };
				promisses.push(loadConfig(gameConfigUrl));
			});

			qLib.all(promisses)
				.then(function (responses) {
					var locale = settings.local.locale || responses[0].locale;

					settings.local.locale = locale;

					responses.forEach(function (gameConfig) {
						updateGamesType(gameConfig);
					});

					T.initLanguage(locale)
						.then(function () {
							responses.forEach(function (gameConfig, index) {
								Object.assign(settings.games[index], gameConfig, { initRun: true });
								settingsReloader(index);
							});
							gameLoader.loadGames(); // Load games when everything is finished
							callback();
						});
				}, function (err) {
					errorHandler.logError('ERROR', 'error getting initial game data', err, {
						url: settings.local.configUrl
					});
					if (err.status === 404) {
						errorHandler.showError(
							'Invalid URL provided. Please check if URL provided is correct.',
							10000);
						return;
					}
					errorHandler.showError('Failed to get initial game configuration data', 1000);
					setTimeout(initialGameSettingsLoad, 1000, games, callback); // Retry after 1s
				});
		}

		function updateGamesType(gameConfig) {
			var gameType = gameConfig.config[gameConfig.module].gameType;

			gameConfig.config[gameConfig.module].moduleGameType = gameType;
			gameConfig.config[gameConfig.module].gameType = settings.convertGameType(gameType);
		}

		function loadConfig(configUrl) {
			return $.ajax(
				configUrl, { dataType: 'json', cache: false }
			);
		}

		function loadVersion() {
			$.ajax('version.json', { dataType: 'json', cache: false })
				.done(function (data) {
					settings.versionData = data;
				});
		}

		function formatErrorConfig(config) {
			var ua = userAgentVersionMap(navigator.userAgent),
				STB = { ABOX: false },
				extraData;

			if (ua.ABOX || ua.MAC) {
				STB = {
					MAC: ua.MAC,
					ABOX: true,
					ABOXVersion: ua.ABOX
				};
			}
			extraData = Object.assign({}, settings.versionData, STB, {
				location: window.location.href,
				configURL: settings.local.configUrl
			});
			return Object.assign({}, settings.local.logging, config, { extraData: extraData });
		}

		function userAgentVersionMap(userAgentStr) {
			var map = {},
				parts = userAgentStr.split(' '),
				kv = [],
				i;

			for (i = 0; i < parts.length; i++) {
				kv = parts[i].split('/', 2);
				if (kv.length === 2) {
					map[kv[0]] = kv[1];
				}
			}
			return map;
		}

		function settingsReloader(gamePlacement) {
			var reloadingGame = settings.games[gamePlacement];

			version.checkAndReload();
			loadConfig(reloadingGame.configUrl)
				.done(function (data) {
					updateGamesType(data);
					Jackpots.registerJackpots(data.jackpotURLs, gamePlacement);
					reloadingGame = Object.assign(reloadingGame, data);
				})
				.fail(function (err) {
					errorHandler.logError('ERROR', 'error getting data from configUrl', err, {
						url: settings.local.configUrl
					});
					errorHandler.showError(T.translate('translate_err5'), 5000);
				})
				.always(function () {
					setTimeout(function () {
						settingsReloader(gamePlacement);
					}, reloadingGame.configRefreshInterval || 60000);
				});
		}

		window.onerror = function (msg, url, line, col, err) {
			errorHandler.logError('ERROR', 'javascript error', null, {
				data: {
					fullErr: err,
					errorMessage: msg,
					line: line,
					col: col,
					stackTrace: err && err.stack ? err.stack : null
				}
			});
		};

		return {
			init: init
		};
	});

